import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { RouterUtils } from '../../shared/utils/src/router.utils';
import { Router } from '@angular/router';
import { CommonServices} from '../../shared/services/src/api';
import {MsgPopupService} from '../../shared/services';

@Directive({
    selector: '[objectLink]'
})
export class ObjectLinkDirective {
    @Input('objectLink') param: any;

    @HostListener('click', ['$event']) onClick(e) {
        const isControlClick = e.ctrlKey || e.metaKey;

        let url = '';
        let option;
        const curCmpnId = global['loginUser'].curCmpnId;

        switch (this.param.type) {
            case 'CONFIGURATION':
            case 'SERVICE':
                url = '/service/detail';
                option =  {
                    curCmpnId : curCmpnId,
                    svcNo: this.param.objNo,
                    contentSelectedTab: 'incident'
                };
                // this.navigate(isControlClick, url, option);
                this.getResourceAccessibleToPromise(curCmpnId, 'service', isControlClick, url, option);
                break;
            case 'ESCALATION':
                url = '/escalation';
                option =  {
                    curCmpnId : curCmpnId,
                    escalPlcyNo: this.param.objNo,
                    viewType: 'detail'
                };

                this.getResourceAccessibleToPromise(curCmpnId, 'escalation', isControlClick, url, option);
                break;
            case 'INTEGRATION':
                url = '/integration/detail';
                option =  {
                    curCmpnId : curCmpnId,
                    targetValue: this.param.objNo,
                    itgrTypeNo: this.param.objNo2
                };
                // this.navigate(isControlClick, url, option);
                this.getResourceAccessibleToPromise(curCmpnId, 'integration', isControlClick, url, option);
                break;
            case 'INCIDENT':
                url = '/incident/incident';
                option =  {
                    curCmpnId : curCmpnId,
                    tcktNo: this.param.objNo,
                    viewType: 'detail'
                };

                //Incident의 경우 resource guard가 false를 return 하여도 전 url로 돌아가지 못하는 현상 발생
                //viewtype을 url의 option을 통하여 구분하기때움으로 판담
                //alert과 escalation도 동일한 현상이 예상되지만 링크를 타는경우에 alert과 escalation은 url자체가 변경됨으로 이 버그가 발생될 일이 없음
                //추후 split view 개선과 연관있음!!!
                this.getResourceAccessibleToPromise(curCmpnId, 'incident', isControlClick, url, option);
                break;
            case 'TEAM':
                url = '/team/detail';
                option =  {
                    curCmpnId : curCmpnId,
                    teamNo: this.param.objNo,
                    contentSelectedTab: 'user'
                };
                // this.navigate(isControlClick, url, option);
                this.getResourceAccessibleToPromise(curCmpnId, 'team', isControlClick, url, option);
                break;
            case 'SCHEDULE':
                url = '/schedule/detail';
                option =  {
                    curCmpnId : curCmpnId,
                    schdNo: this.param.objNo
                };
                // this.navigate(isControlClick, url, option);
                this.getResourceAccessibleToPromise(curCmpnId, 'schedule', isControlClick, url, option);
                break;
            case 'USER':
                url = '/user/detail';
                option =  {
                    curCmpnId : curCmpnId,
                    userNo: this.param.objNo
                };
                this.navigate(isControlClick, url, option);
                // this.getResourceAccessibleToPromise(curCmpnId, 'user', isControlClick, url, option);
                break;
            case 'EXTENSION':
                url = '/extension/list';
                option =  {
                    curCmpnId : curCmpnId,
                    extnNm: this.param.objNo
                };
                this.navigate(isControlClick, url, option);
                // this.getResourceAccessibleToPromise(curCmpnId, 'extension', isControlClick, url, option);
                break;
            case 'NOTIFICATION':
                url = `/an/noti-template/list?notiTmplNm=${encodeURIComponent(this.param.objNo)}`;
                // option =  {
                //     curCmpnId : curCmpnId,
                //     notiTmplNm: this.param.objNo
                // };
                // this.navigate(isControlClick, url, option);
                location.href = location.origin + RouterUtils.makeUrl(url);
                break;
        }
    }

    constructor(private el: ElementRef,
                public _router: Router,
                private commonServices: CommonServices,
                private _msgPopupService: MsgPopupService) { }

    navigate(isControlClick, url, option) {
        if (isControlClick) {
            RouterUtils.newWindow(url, option);
        } else {
            RouterUtils.navigate(this._router, url, option);
        }
    }

    getResourceAccessibleToPromise(curCmpnId, rsrcType, isControlClick, url, option) {
        this.commonServices.getResourceAccessibleToPromise(curCmpnId, rsrcType, this.param.objNo)
            .then(_data => {
                const IF_ACCESSIBLE = _data > 0;

                if (!IF_ACCESSIBLE) {
                    this._msgPopupService.msgEvent.emit({
                        'header_msg' : 'MK.01355',   // 접근 거부
                        'contents_msg' : 'MK.01356', // 접근 권한이 없습니다. 자세한 내용은 관리자에게 문의해주세요.
                        'close_btn_use_flag' : true,
                        'redirect_flag': this.param.flag});
                    return;
                } else {
                    this.navigate(isControlClick, url, option);
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/objectLink/objectLink.directive.ts